import defineAbilitiesFor from '@/services/ability.service'

export default {
  SET_CURRENT_USER(state, currentUserData) {
    state.currentUser = currentUserData
  },
  SET_USER_ABILITIES(state, currentUserData) {
    state.abilities = currentUserData.abilities
  },
  DEFINE_USER_ABILITIES(state) {
    state.definedAbilites = defineAbilitiesFor()
  },
}
